const MAX_ITERATIONS_NUMBER = 100;

const getElementTopOffset = (element: HTMLElement | null, iterator = 0): number => {
    if (!element || iterator > MAX_ITERATIONS_NUMBER) {
        return 0;
    }

    return getElementTopOffset(element.offsetParent as HTMLElement, ++iterator) + element.offsetTop;
};

export default getElementTopOffset;
